
  import { Component, Vue } from "vue-property-decorator";
  import VueCookies from "vue-cookies";

  import { mapGetters } from "vuex";
  import moment from "moment";

  import accountService from "@/services/account.service";
  import epicService from "@/services/epic.service";
  import errorsService from "@/services/errors.service";
  import steamService from "@/services/steam.service";
  import twitchService from "@/services/twitch.service";

  import { IConnectModel } from "@/models/account.model";
  import { IErrorModel } from "@/models/errors.model";
  import recaptchaService from "../../services/recaptcha.service";

  Vue.use(VueCookies);

  @Component({
    computed: {
      ...mapGetters([
        "user",
        "redirectUrl",
        "isLinkingSteamLoading",
        "isLinkingTwitchLoading",
        "isRefreshTwitchLoading",
        "isLinkingEpicGamesLoading",
        "isRefreshEpicGamesLoading",
        "isRefreshSteamLoading",
        "token",
        "connects"
      ]),
    },
  })
  export default class LinkAccount extends Vue {
    data() {
      return {
        errors: new Array<IErrorModel>(),
        showTwitchSection: true,
        showEpicGamesSection: true,
        studio: '',
        twitchDropLink: '',
        useSEGARedeemer: false,
      };
    }

    created() {
      this.$data.useSEGARedeemer = this.$data.RCEnvironment.VUE_APP_USE_SEGA_REDEEMER == true;
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
      this.$data.twitchDropLink = this.$data.RCEnvironment.VUE_APP_FRONT_URL + 'amplitude-studios/humankind/drops/personas';
    }

    getLastCheckTime(lastCheck: Date): string {
      if (!lastCheck) {
        return "0 second";
      }

      const duration = moment.duration(moment.utc().diff(moment.utc(lastCheck)));
      let time = Math.round(duration.asDays());
      let returnTime = time + " day";

      if (time < 1) {
        time = Math.round(duration.asHours());
        returnTime = time + " hour";

        if (time < 1) {
          time = Math.round(duration.asMinutes());
          returnTime = time + " minute";

          if (time < 1) {
            time = Math.round(duration.asSeconds());
            returnTime = time + " second";
          }
        }
      }

      returnTime += (time > 1 ? "s" : "");

      return returnTime;
    }

    link(platform: string) {
      this.$store.dispatch("updateIsLinking" + this.toPascalCase(platform) + "Loading", true);
      this.$data.errors = new Array<IErrorModel>();

      if (this.$data.RCEnvironment.VUE_APP_ENABLE_RECAPTCHA == true) {
        recaptchaService.getToken(this, "link")
          .then((token) => {
            setTimeout(() => {
              this.validateProfile(platform, token);
            }, 300);
          })
          .catch((error) => {
            this.$data.isLinking = false;
            errorsService.handleErrors(this, error);
          });
      } else {
        this.validateProfile(platform);
      }
    }

    unlink(platform: string) {
      if (this.$store.getters.token != null) {
        switch (platform) {
          case "epic-games":
            epicService.unlinkEpicGames(this, this.$store.getters.token);
            break;

          case "steam":
            const steamConnect: IConnectModel = this.$store.getters.connects.find((connect: IConnectModel) => connect.CanonicalName == "steam");
            if (steamConnect != null) {
              steamService.unlinkSteam(this, this.$store.getters.token, steamConnect.Id_Account);
            }

            break;

          case "twitch":
            twitchService.unlinkTwitch(this, this.$store.getters.token);
            break;

          case "game-pass":
            break;
        }
      }
    }

    goToUpdateEmail() {
      this.$router.push({ name: "UpdateEmail" });
    }

    toPascalCase(text: string) {
      return text.replace(/(^\w|-\w)/g, this.clearAndUpper);
    }

    clearAndUpper(text: string) {
      return text.replace(/-/, "").toUpperCase();
    }

    private validateProfile(platform: string, token: string = ''): void {
      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "profile/validate";
      accountService
        .post<any, any>(this, url, { Token: token })
        .then((response) => {
          if (!response.Success) {
            this.$store.dispatch("updateIsLinking" + this.toPascalCase(platform) + "Loading", false);
            this.$data.errors = [
              {
                Property: "",
                ErrorMessage: "ERROR_USER_IP_BANNED_" + this.toPascalCase(platform) + "_LINK",
              } as IErrorModel,
            ];
            return;
          }
          switch (platform) {
            case "epic-games":
              epicService.goToEpicGames(this, this.$data.useSEGARedeemer, this.$store.getters.redirectUrl);
              break;

            case "steam":
              steamService.goToSteam(this, this.$store.getters.redirectUrl);
              break;

            case "twitch":
              twitchService.goToTwitch(this, this.$store.getters.redirectUrl
              );
              break;

            case "game-pass":
              break;
          }
        })
        .catch(() => {
          this.$store.dispatch("updateIsLinking" + this.toPascalCase(platform) + "Loading", false);
        });
    }
  }
